export default "__VITE_ASSET__Dv_HJyBN__"